<template>
		<el-row id="menu-checkout">
		<el-col v-if="display" class="fs-count">
			<el-row class="input-number">
				<el-col :span="8" @click.native="DecreaseToCheckout" class="btn text-center">
					<i class="fas fa-minus" style="vertical-align: middle;"></i>
				</el-col>
				<el-col :span="8" class="btn text-center input-number-value">
					{{ num }}
				</el-col>
				<el-col :span="8" @click.native="IcrQtyToCheckout" class="btn text-center">
					<i class="fas fa-plus" style="vertical-align: middle;"></i>
				</el-col>
			</el-row>
		</el-col>
		<el-col v-else class="fs-gray-scale fs-count">
			<el-row class="input-number">
				<el-col :span="8" class="btn text-center">
					<i class="fas fa-minus" style="vertical-align: middle;"></i>
				</el-col>
				<el-col :span="8" class="btn text-center input-number-value">
					{{ num }}
				</el-col>
				<el-col :span="8" class="btn text-center">
					<i class="fas fa-plus" style="vertical-align: middle;"></i>
				</el-col>
			</el-row>
		</el-col>
	</el-row>
</template>
<script>
export default {
	props: [ 'index', 'menudetail', 'options', 'branchdetail', 'notaion' , 'flag', 'display'],
	data () {
		return {
			num: 1,
			subtotal: this.menudetail.price
		}
	},
	created () {
		let fs = this
		fs.num = fs.qty
		fs.$store.dispatch('getQtyMenu', fs.index).then((response) => {
			// if (response) {
				fs.num = response.qty
				fs.subtotal = response.subtotal
			// }
		})
	},
	methods: {
		IcrQtyToCheckout () {
			let fs = this
			fs.$store.dispatch('IcrQtyToCheckout', {
				index: fs.index,
				menu: fs.menudetail,
				options: fs.options,
				branchdetail: fs.branchdetail,
				notaion: fs.notaion,
				flag: fs.flag
			})
		},
		DecreaseToCheckout () {
			let fs = this
			if (fs.num > 1) {
				fs.$store.dispatch('DcrQtyToCheckout', {
					index: fs.index,
					menu: fs.menudetail,
					options: fs.options,
					branchdetail: fs.branchdetail,
					notaion: fs.notaion,
					flag: fs.flag
				})
			} else {
				fs.$store.dispatch('deleteMenuInCart', { index: fs.index, menu: fs.menudetail, branchdetail: fs.branchdetail })
			}
		}
	},
	computed: {
		AmountCart () {
			let fs = this
			return fs.$store.getters.AmountCart
		}
	},
	watch: {
		AmountCart (value) {
			let fs = this
			let index = value.findIndex( element => element.id === fs.menudetail.id)
			if (index > -1) {
				fs.num = value[fs.index].qty
				fs.subtotal = value[fs.index].subtotal
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/element/elementCheckout.vue